import React from "react";
import { useInView } from "../../hooks/useInView";

// Aplica a animação de entrada `.reveal` (definida no theme.css) quando o elemento aparece na tela.
// `delay` de 1 a 4 escalona elementos lado a lado.
const Reveal = ({ as: Tag = "div", className = "", delay, children, ...rest }) => {
  const [ref, inView] = useInView();
  const classes = ["reveal", delay && `d${delay}`, inView && "in", className].filter(Boolean).join(" ");

  return (
    <Tag ref={ref} className={classes} {...rest}>
      {children}
    </Tag>
  );
};

export default Reveal;
